export class RoleRightCreationRequestModel {
    constructor() {
        this.pages = [];
    }
}
